const translation = {
  offRules: 'Oficiālie Noteikumi',
  // Navigation pages
  play: 'SPĒLĒT',
  recent: 'NESENIE',
  howToPlay: 'KĀ SPĒLĒT',

  // Card
  signUp: 'REĢISTRĒJIETIES, LAI SPĒLĒTU',
  viewMy: 'SKATĪT MANU KARTIŅU',
  view: 'SKATĪT KARTIŅU',
  registered: 'REĢISTRĒTS',
  entry: 'Dalībnieks',
  entries: 'Dalībnieki',
  contestClosed: 'BINGO KONKURSS IR SLĒGTS',
  ifNecessary: 'JA NEPIECIEŠAMS',

  //Signup modal
  reg: 'Jūs esat reģistrējies, lai spēlētu Olybet Bingo',
  rel: 'Jūsu Bingo karte tiks atklāta:',
  come: 'Atgriezieties, lai redzētu savu kartīti, kad notikums sāksies',
  priz: 'Balvas',
  regen: 'BINGO KARTĪTE SPĒLES LAIKĀ AUTOMĀTISKI PIEŠĶIR PUNKTUS',
  //Wait modal
  hangTight: 'SATURIETIES!',
  cardToBeGenerated: 'Gaidām, kad tiks ģenerēta BINGO KARTE.',
  mayTakeUpFewMinutes: 'TAS VAR AIZŅEMT LĪDZ PAT DAŽĀM MINŪTĒM',

  // How to play page
  vert: 'VERTIKĀLI',
  horiz: 'HORIZONTĀLI',
  diag: 'DIAGONĀLI',
  fullCard: 'PILNA KARTĪTE',
  earnEntriesIntoDraw:
    'VINNĒJIET BALVAS, IZSVĪTROJOT PILNAS RINDAS, DIAGONĀLES VAI VISU KARTI. LODZIŅŠ TIEK UZSKATĪTS PAR VINNĒTU, JA TAJĀ IETVERTAIS NOTIKUMS IR NOTICIS.',
  autoScoresDuringGame:
    'BINGO KARTĪTE SPĒLES LAIKĀ AUTOMĀTISKI PIEŠĶIR PUNKTUS',
  clickForMoreInfo: 'Lai uzzinātu vairāk, noklikšķiniet šeit, lai skatītu',
  SOG: 'SOG - Metiens pa vārtiem (jebkurš metiens pa vārtiem. Neietver bloķētus metienus vai metienus, kas trāpīja pa vārtu stabu)',
  PPG: 'PPG - Vārti skaitliskajā vairākumā (vārti, ko komanda gūst, spēlējot skaitliskajā vairākumā). Piemēram, komanda, kas spēlē ar skaitlisko pārsvaru 5v4, 5v3 vai 4v3)',
  SHG: 'SHG - Vārti skaitliskajā mazākumā (vārti, kurus guvusi komanda, kuras spēlētājs izcieš sodu)',
  PIM: 'PIM - sodi minūtēs',
  FOPercent: 'FO% - Iemetienu procents',
  PTS: 'PTS - Punkti (vārti vai piespēles)',
  entryPerRow: 'IESNIEGŠANA VIENĀ RINDĀ',
  totalEntries: 'KOPĒJAIS DALĪBNIEKU SKAITS',
  perRow: 'VIENĀ RINDĀ',

  //Home page
  bingoMayTakeUp:
    'Bingo kartēm var būt nepieciešamas līdz 20 minūtēm pēc spēles, lai reģistrētu visus notikumus',
  welcomeTo: 'Laipni lūdzam BingOly!',
  reviewInRecent: 'Pārskatiet savas iepriekšējās kartes cilnē Nesenās',
  thanksForPlaying:
    'Paldies, ka spēlējat Olybet Bingo! Pārskatiet savas 2022-2023. gada sezonas kartes sadaļā "Nesenās"',
  agreeToRules: 'Reģistrējoties jūs apstiprināt un piekrītat',

  //Recent page
  noRecentContests: 'Nesen notikušu konkursu nav',
  //Game field page
  gamePrizeText:
    'Laimējiet 100 €, ja jums izdosies aizpildīt visus kartiņu, vai 5 €, ja jums izdosies aizpildīt vismaz vienu rindu vai diagonāli. Balvas tiks sadalītas darba laikā.',
  cardUpdateAfterPeriod: 'Kartiņa tiks atjaunināta ik pēc 30 minūtēm',
  anyLine: 'JEBKURA LĪNIJA',
  vertLines: 'VERTIKĀLĀS LĪNIJAS',
  line: 'LĪNIJA',
  horzLines: 'HORIZONTĀLĀS LĪNIJAS',

  //Onboarding page
  letsGetStarted: 'Sāksim',
  makeSureToEnterSelections:
    'Pārliecinieties, ka katru dienu ievadāt savu izvēli, lai sacenstos par ikdienas balvām. Neaizmirstiet ievadīt savu izvēli jautājumam par neizšķirtu atbildi, pirms iesniedzat savu izvēli. Savu izvēli varat rediģēt līdz pat tiešraides spēles sākumam. Pelniet punktus par katru pareizo prognozi.',
  playWithFriends:
    'Spēlējiet ar draugiem. Kam ir spēle? Izaiciniet draugus spēlēt privātā līgā. Dodieties uz līderu tablo sadaļu, nospiediet pogu Izveidot, lai sāktu, un kopīgojiet PIN kodu ar draugiem, lai pievienotos.',
  scoring: 'Vērtēšana',
  challengeFriends: 'Izaicini draugus',
  skip: 'izlaist',
  next: 'nākamais',

  logout: 'Izrakstīties',
  returnToGamezone: 'Atgriezties GameZone',
  rules: 'NOTEIKUMI',
  back: 'Atpakaļ',

  bingo: 'BingOly',
  gamezone: 'Gamezone',
  justAFewMinutes: 'Tikai dažas minūtes, lūdzu, atsvaidziniet lapu',
  fourCorners: 'ČETRI STŪRI',
  rulesNotFound: 'Noteikumi nav atrasti',
  offWebsiteText:
    'PAR GALVENO REZULTĀTU AVOTU TIKS UZSKATĪTA PASĀKUMA OFICIĀLĀ TĪMEKĻA VIETNE. JA TĀDI NEBŪS PIEEJAMI, TIKS IZMANTOTI CITI UZTICAMI AVOTI VAI TIEŠRAIDES VIDEOIERAKSTI.',
  accountInfo: 'Konta informācija',
  availableGames: 'Pieejamās spēles',
  backToOlybet: 'Atpakaļ uz OlyBet',
  confirmNewPassword: 'Apstipriniet jauno paroli',
  confirmNewPasswordIsRequired: 'Apstipriniet jauno paroli ir obligāts lauks',
  confirmPassword: 'Apstiprināt paroli',
  confirmPasswordIsRequired: 'Confirm Password is a required field',
  contactNumber: 'Kontaktpersonas numurs',
  country: 'Dzīvesvietas valsts',
  countryIsRequired: 'Valsts ir obligāts lauks',
  continue: 'Turpināt',
  days: 'Dienas',
  didNotMeanToUnsubscribe: 'Nejauši anulēji savu abonementu?',
  email: 'E-pasts',
  emailAddressAlreadyInUse: 'E-pasta adrese jau tiek izmantota',
  emailIsRequired: 'E-pasts ir obligāts lauks',
  emailOrUsername: 'E-pasts vai lietotājvārds',
  emailOrUsernameIsRequired: 'E-pasts vai lietotājvārds ir obligāts lauks',
  enterYourDetails: 'Lūdzu, ievadi savus datus zemāk',
  enterYourEmail: 'Ievadi savu e-pastu, lai atiestatītu paroli',
  errorDuringLogin: 'Kļūda pieteikšanās laikā',
  errorDuringRegistration: 'Kļūda reģistrācijas laikā',
  errorDuringSubscribing: 'Error during subscribing',
  errorDuringUnsubscribing: 'Kļūda abonēšanas anulēšanas laikā',
  errorUpdatingProfile: 'Atjauninot profilu, radās kļūda',
  firstName: 'Vārds',
  firstNameIsRequired: 'Vārds ir obligāts lauks',
  firstNameMusBeAtLeast: 'Vārdam ir jābūt vismaz 3 rakstzīmēm',
  firstNameMustNotExceed: 'Vārds nedrīkst pārsniegt 100 rakstzīmes',
  forgotPassword: 'Aizmirsi paroli',
  full: 'PILNS',
  gameDetails: 'Spēles detaļas',
  getResetLink: 'Saņemiet atiestatīšanas saiti',
  goodbye: 'Uz redzēšanos!',
  inappropriateWordsNotAllowed: 'Nepiedienīgi vārdi un frāzes nav atļauti',
  informationAndPromotionalAgreement:
    'Es piekrītu saņemt informāciju un reklāmas piedāvājumus no OlyBet uz šeit norādīto kontaktinformāciju. Es varu mainīt šīs atļaujas jebkurā laikā, klikšķinot uz saites mārketinga paziņojumu lejasdaļā. Vairāk informācijas par datu apstrādi skati Privātuma politikas paziņojumā.',
  inOrderToPlayAndRedeemPrizes:
    'Lai spēlētu un pretendētu uz balvām, Tavai kontaktinformācijai jābūt precīzai un apstiprinātai. Dažas no balvām tiek izmaksātas uz OlyBet kontu. Lai saņemtu šīs balvas, Tev ir nepieciešams OlyBet konts ar atbilstošu informāciju (vārds un e-pasts).',
  invalidCredentials: 'Nederīgi akreditācijas dati',
  invalidEmailFormat: 'Invalid email format',
  itIsRequiredField: 'Šis ir obligāts lauks',
  joinNow: 'Pievienoties',
  lastName: 'Uzvārds',
  laststNameIsRequired: 'Uzvārds ir obligāts lauks',
  laststNameMusBeAtLeast: 'Uzvārdam ir jābūt vismaz 3 rakstzīmēm',
  laststNameMustNotExceed: 'Uzvārds nedrīkst pārsniegt 100 rakstzīmes',
  legalConsent: 'Juridisko dokumentu piekrišana',
  lines: 'LĪNIJAS',
  live: 'LIVE',
  liveGames: 'Live spēles',
  login: 'Login',
  marketingConsent: 'Piekrišana mārketingam',
  mobileNumber: 'Mobilā telefona numurs',
  mobileNumberIsRequired: 'Mobilā tālruņa numurs ir obligāts lauks',
  mobileNumberMustBeAtLeast:
    'Mobilā tālruņa numuram ir jābūt vismaz 6 rakstzīmēm',
  mobileNumberMustNotExceed:
    'Mobilā tālruņa numurs nedrīkst pārsniegt 15 rakstzīmes',
  mustBeChecked: 'Jāpārbauda',
  mustContainFrom8To20Characters: 'Must contain from 8 to 20 characters',
  mustContainOneLowercase: 'Must contain at least one lowercase',
  mustContainOneNumber: 'Must contain at least one number',
  mustContainOneUppercase: 'Must contain at least one uppercase',
  myContest: 'Manas sacīkstes',
  myHistory: 'Mana Vēsture',
  nationality: 'Tautība',
  newPassword: 'Jauna parole',
  newPasswordIsRequired: 'Jauna parole ir obligāts lauks',
  nickname: 'Segvārds',
  nicknameAlredyInUse: 'Segvārds jau tiek lietots',
  nicknameIsRequired: 'Segvārds ir obligāts lauks',
  noHistoryYet: 'Vēl nav vēstures',
  noUpcomingContestsYet: 'Pagaidām nav gaidāmo konkursu',
  oops: 'Hmm! Kaut kas nogāja greizi...',
  over$PrizeValueWon: 'Over <1>$1,000,000</1> prize value won',
  password: 'Parole',
  passwordDoNotMatch: 'Paroles nesakrīt',
  passwordIsRequired: 'Parole ir obligāts lauks',
  passwordNotMeetCriteria: 'Parole neatbilst kritērijiem',
  passwordSuccessfullyReset: 'Parole ir veiksmīgi atiestatīta',
  personalDetails: 'Personiskā informācija',
  playNow: 'Spēlēt tagad',
  pleaseCheckYourEmailInbox: 'Lūdzu, pārbaudiet savu e-pasta iesūtni',
  pos: 'Pos.',
  preferences: 'Preferencijos',
  profile: 'Profils',
  pts: 'PTS',
  recentWinners: 'Jaunākie uzvarētāji',
  region: 'Novads',
  resetLinkSent: 'Atiestatīšanas saite ir nosūtīta',
  resetPassword: 'Atiestatīt paroli',
  resubscribe: 'Pieteikties atkārtoti',
  returnToLogin: 'Return to login',
  saveChanges: 'Saglabāt izmaiņas',
  signIn: 'Ielogoties',
  success: 'Tev izdevās!',
  successfullyLoggedIn: 'Veiksmīgi pieslēdzies',
  successfullySentResetLink:
    'Atiestatīšanas saite uz jūsu e-pastu ir veiksmīgi nosūtīta',
  successfullySignedUp: 'Tev izdevās!',
  successfullySubscribed: 'Successfully subscribed',
  successfullyUnsubscribed: 'Veiksmīgi anulēts abonements',
  successfullyUpdatedProfile: 'Profils ir veiksmīgi atjaunināts',
  unsubscribe: 'Atteikties no paziņojumiem',
  upload: 'Augšupielādēt',
  username: 'Lietotājvārds',
  usernameAlreadyInUse: 'Lietotājvārds jau tiek izmantots',
  usernameIsRequired: 'Username is a required field',
  veryStrongPassword: 'Very strong password',
  welcomeBack: 'Laipni lūdzam atpakaļ!',
  win: 'UZVARĒT',
  winner: 'Uzvarētājs',
  youHaveSuccesfullyUnsubscribed:
    'Tu esi veiksmīgi anulējis OlyBet paziņojumus.',
  yourEmail: 'Your email',
  youWishToUnsubscribe:
    'Ja esi pārliecināts, ka vēlies anulēt OlyBet paziņojumu abonementu, lūdzu, klikšķini zemāk.',
  zipCode: 'Pasta indekss',
  zipCodeIsRequired: 'Pasta indekss ir obligāts lauks',
  zipCodeMustBeAtLeast: 'Pasta indeksam ir jābūt vismaz 3 rakstzīmēm',
  zipCodeMustNotExceed: 'Pasta indekss nedrīkst pārsniegt 10 rakstzīmes',
  winPrizes:
    'VINNĒJIET BALVAS, SAVĀCOT RINDAS SAVĀ BINGOLĪ KARTIŅĀ DZĪVĀS SPĒLES LAIKĀ.',
  letsGo: 'Ejam',
  inAnyCase:
    'Lūdzu, ņemiet vērā, ka mēs joprojām sazināsimies ar jums, lai sniegtu svarīgu informāciju saistībā ar jūsu dalību spēlē, piemēram, apstiprinājumu par laimēto balvu. Lai uzzinātu vairāk par to, kā tiek apstrādāti jūsu personas dati, lūdzu, skatiet mūsu konfidencialitātes politiku.',
  termsAndConditions: 'Noteikumi un nosacījumi',
  privacyNotice: 'Paziņojums par konfidencialitāti',
};
export default translation;
